import styled from 'styled-components';

export const StyledPriceFakePrice = styled.div`
  height: 17px;
`;

export const StyledListingItemPriceLabel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ItemPriceDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
  line-height: 12px;
`;

export const StartPriceLabel = styled.span`
  font-size: 12px;
  margin: 2px 0 2px 0;
  text-align: end;
  color: ${({ theme }) => theme.palette.darkGrey};
  opacity: 0.75;
`;

export const RoomPeopleCount = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.D500};
  opacity: 0.75;
  white-space: nowrap;
  margin-bottom: 2px;
`;

export const PriceInEUR = styled.div<{ fontSize?: boolean }>`
  color: ${({ theme }) => theme.palette.darkGrey};
  font-size: 24px;
  font-weight: 600;
  text-align: right;
  height: 30px;
  margin-top: -8px;
`;
export const DiscountedPriceContainer = styled.span<{
  size: number;
}>`
  color: ${({ theme }) => theme.palette.pinkSwan};
  text-transform: uppercase;
  font-size: ${({ size }) => size}px;
  letter-spacing: 0.6px;
  font-weight: 600;
`;
export const OriginalPriceContainer = styled.span<{
  size: number;
  noLine?: boolean;
}>`
  color: ${({ theme }) => theme.palette.NL100};
  text-decoration: ${({ noLine }) => (noLine ? 'none' : 'line-through')};
  text-transform: uppercase;
  font-size: ${({ size }) => size}px;
  letter-spacing: 0.6px;
  font-weight: 600;
`;
